<template>
   <v-container pt-2>
      <v-layout column>
         <a-date-field clearable dateFormat="DD/MM/YYYY" label="Data Inicial" rid="workflow.dateRange"
                        v-model="filterData.dateRange[0]" validate="dateDMY" xs12></a-date-field>
         <a-date-field clearable dateFormat="DD/MM/YYYY" label="Data Final" rid="workflow.dateRange"
                        v-model="filterData.dateRange[1]" validate="dateDMY" xs12></a-date-field>
         <a-select-field clearable label="Tipo de Contrato" obj="productType"
                        v-model="filterData.productTypeId" ref="productTypeField"></a-select-field>
      </v-layout>
   </v-container>
</template>

<script>
   export default {
      props: {
         execute: {
            type: Boolean,
            required: false,
            default: false
         }
      },

      data () {
         return {
            filterData: {
               productTypeId: null,
               dateRange: [null, null]
            }
         };
      },

      watch: {
         reloadKey: {
            immediate: true,
            handler: function () {
               this.$nextTick(() => this.reloadFilters());
            }
         },
         execute (val) {
            val && this.applyFilter();
         }
      },

      methods: {
         applyFilter() {
            let filters = [];

            let rangeLabel = '';
            if (this.filterData.dateRange) {
               let dateRange = this.filterData.dateRange.filter(d => d !== null);
               dateRange.forEach((v, i) => dateRange[i] = this.$moment(v).format('YYYY-MM-DD'));

               if (dateRange.length === 2)
                  rangeLabel += (dateRange[0] === dateRange[1]) ? 'Em ' + this.$moment(dateRange[0]).format('DD/MM/YYYY') : `Entre ${this.$moment(dateRange[0]).format('DD/MM/YYYY')} e ${this.$moment(dateRange[1]).format('DD/MM/YYYY')} `;
               else if (dateRange.length)
                  rangeLabel += 'Em ' + this.$moment(dateRange[0]).format('DD/MM/YYYY');
               else
                  rangeLabel = '';

               if (!rangeLabel) {
                  this.filterData.dateRange = [null, null];
               }

               filters.push({
                  field: 'dateRange',
                  value: this.filterData.dateRange,
                  label: rangeLabel
               });
            }

            let productTypeName;
            this.filterData.productTypeId ? productTypeName = this.$refs.productTypeField.items.find(el => el.id == this.filterData.productTypeId).name : productTypeName = null;

            filters.push({
               field: 'productTypeId',
               value: this.filterData.productTypeId,
               label: productTypeName
            });

            this.$store.dispatch('updateAllPageFilters', filters);
            setTimeout(() => this.$emit('close'), 150);
         },

         reloadFilters() {
            this.$util.updateObj(this.filterData, this.$store.getters.activePageFilters);

            if (!this.filterData.dateRange) {
               this.filterData.dateRange = [null, null];
            }
         }
      }
   };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/AffiliateFilter.vue